export function isNullish(value) {
  return value === null || value === undefined;
}
